module.exports = {"130429100":"临洺关镇","130429101":"大北汪镇","130429102":"张西堡镇","130429103":"广府镇","130429104":"南沿村镇","130429105":"永合会镇","130429200":"西苏乡","130429201":"界河店乡","130429202":"刘营乡","130429203":"刘汉乡","130429204":"正西乡","130429205":"讲武乡","130429206":"曲陌乡","130429207":"辛庄堡乡","130429208":"小龙马乡","130429209":"东杨庄乡","130429210":"小西堡乡","130429211":"西河庄乡","130429213":"西阳城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130429.json
// module id = 207
// module chunks = 0